module.exports = __webpack_public_path__ + "img/tel-icon.9da12ef5.png";